import { InboxRealtimeEventDto } from '@spike/omnichannel-action';
import { AppointmentListDto } from '@spike/appointments-list-action';
import { BlockCalendarDto } from '@spike/block-calendar-action';
import { BookingDto, AppointmentDto } from '@spike/bookings-action';
import { MarketplaceDto } from '@spike/marketplace-action';
import { ProspectMessageDto } from 'actions/prospectMessage/prospectMessageDtos';
import { StaffDto } from 'actions/staff/StaffDto';
import { SmsMessageDto } from 'actions/twoWaySms/twoWaySmsDtos';
import { UserReceiptDto } from 'actions/userNotifications/userNotificationsDtos';

export interface BlockCalendarWebSocketsMessage {
    block_calendar?: BlockCalendarDto;
    deleted?: Array<number>;
    destroyed: boolean;
}

export interface AppointmentsWebSocketsMessage {
    booking?: BookingDto;
    appointment?: AppointmentDto;
    canceled?: Array<number>;
    deleted?: Array<number>;
    new_appt_payload?: AppointmentListDto;
}

export interface PosWebSocketMessage {
    body: PosWebSocketMessageBody;
}

export interface PosWebSocketMessageBody {
    message: string;
    status: string;
}

export interface MarketplaceWebSocketsMessage {
    marketplace: MarketplaceDto;
}

export interface StaffWebSocketsMessage {
    staff: StaffDto;
}

export interface TwoWaySmsWebSocketsMessage {
    message: SmsMessageDto | ProspectMessageDto;
    message_type: string;
    unread_count: number;
}

/**
 * Broadcast of the unified inbox `InboxChannel` (stream `inbox_channel_{marketplace_id}`).
 * The payload IS the realtime event — no wrapper key. The legacy `MessagesChannel` carries nothing for the inbox.
 */
export type InboxWebSocketsMessage = Partial<InboxRealtimeEventDto>;

export interface UserNofiticationsWebSocketsMessage {
    notification: UserNotificationDto;
    notification_receipt: UserReceiptDto;
}

export interface UserNotificationDto {
    channel?: string;
    id: number | undefined;
    uuid?: string;
    marketplace_id: number;
    body: string | HTMLBodyElement;
    subject: string | HTMLBodyElement;
    type_id: string;
    source?: string;
    status?: string;
    target_id?: number;
    target_type?: string;
    target_status?: number;
    updated_at?: Date;
    created_at?: Date;
}

export interface BulkUploadWebSocketMessage {
    event: string;
    total_records: number;
    record_number: number;
    percentage: number;
    successfully_imported: number;
    errors: number;
}

export interface RecurringSeriesWebSocketMessage {
    series?: {
        uuid: string;
        status: string;
    };
    progress?: {
        total: number;
        processed: number;
        created: number;
        skipped: number;
        failed: number;
        needs_review: number;
    };
}

export const PosSuccessStatus = 'APPROVED';
export const PosFailureStatus = 'FAILURE';
